module.exports = __webpack_public_path__ + "img/1330549331.c8ba7aa8.jpg";